<template>
<div class="transfers-detail" v-if="flag==index&&detailShow" :style="{height:transferDetail.entities&&transferDetail.entities.length?transferDetail.entities.length*25+detailHeight+'px':detailHeight+'px'}">
    <div class="transfers-detail-title">{{$t('language.popup.transferDetails')}}</div>
    <div class="detail-count" v-if="transferDetail.state2.status==1">
         <div class="transfer-line" >{{$t('language.common.countFiles')}}:({{transferDetail.state2.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{transferDetail.state2.totalBytes|formatByte}})</div>
    </div>
    <div class="detail-one">
        <div class="transfer-line" @click.stop="toSourceCatalog(transferDetail.state2)"><span style="float:left;">{{$t('language.common.from')}}:</span>
            <div class="catelog-color catelog-style" v-show="transferDetail.state2.branchType!=='share'" :title="transferDetail.state2.sourceNode|getCatalog|getCatalogTitle">{{transferDetail.state2.sourceNode|getCatalog}}</div>
            <div class="catelog-color catelog-style" v-show="transferDetail.state2.branchType==='share'" :title="transferDetail.state2.sharePath|getCatalog|getCatalogTitle">{{transferDetail.state2.sharePath|getCatalog|ellipsis}}</div>
        </div>
        <div class="transfer-line" @click.stop="toAimCatalog(transferDetail.state2)"><span style="float:left;">{{$t('language.common.to')}}:</span>
            <div class="catelog-color catelog-style" :title="transferDetail.state2.desNode|getCatalog|getCatalogTitle">{{transferDetail.state2.desNode|getCatalog}}</div>
        </div>
    </div>
    <div class="detail-two">
        <div class="transfer-line">{{$t('language.common.fileProcess')}}:
            <span v-if="transferDetail.state2.status!=0">{{transferDetail.state2.readyTranFileCount}}<span v-if="transferDetail.state2.readyTranFileCount!=null&&transferDetail.state2.totalFileCount!=null">/</span>{{transferDetail.state2.readyFindFileCount}}</span>
            </div>
        <div class="transfer-line">
            <span class="transfer-column-left">{{$t('language.common.dataProcess')}}:
                <span v-if="transferDetail.state2.status!=0"> {{transferDetail.state2.readedBytes|formatByte}}
                <span v-if="transferDetail.state2.readedBytes!=null&&transferDetail.state2.totalBytes!=null">/</span>
                {{transferDetail.state2.totalBytes|formatByte}}</span>
            </span>
           
            <span class="transfer-column-right">{{$t('language.popup.progress')}}:<span v-if="transferDetail.state2.status>1">{{percent+'%'}}</span></span>
        </div>
        <div class="transfer-line">
            <span class="transfer-column-left">{{$t('language.common.startTime')}}:
                <span v-if="transferDetail.state2.status!=0">{{transferDetail.state2.taskStartTimeLong|transferTime}}</span></span>
            <span class="transfer-column-right">{{$t('language.common.currentRate')}}: <span v-if="transferDetail.state2.status>1">{{speed}}</span></span>
        </div>
    </div>
    <div class="detail-three" v-if="transferDetail&&transferDetail.entities" :style="{height:transferDetail.entities&&transferDetail.entities.length?transferDetail.entities.length*25+20+'px':'0px'}">
        <div class="transfer-line" :key="index" v-for="(item ,index) in transferDetail.entities">
            <span class="transfer-column-left transfering-file-line" :title="getTitle(item)">
                {{item.fileNode|getCatalog}}\{{item.filename}}
            </span>
            <span v-if="!isVip()">
                 <span class="transfer-column-right transfering-file-line upgradeMulti"  v-if="item.rate==-1" @click.stop="switchToPay()">{{$t('language.common.upgradeMulti')}}</span>
                 <span class="transfer-column-right transfering-file-line" v-if="item.rate!=-1">{{item.rate}}%</span>
            </span>
            <span v-else>
                 <span class="transfer-column-right transfering-file-line"  v-if="item.rate&&item.rate!=-1">{{item.rate}}%</span>
                 <span class="transfer-column-right transfering-file-line" v-else >0%</span>    
            </span>
        </div>
    </div>
    <div class="detail-four">
        <div class="transfer-line">
            <div class="icon-util shop-cart shop-cart-position"></div>
            <span class="transfer-line-des" v-if="!isVip()">{{$t('language.common.noVip')}}</span>
            <span class="transfer-line-des" v-if="isVip()">{{$t('language.common.vipThanks')}}</span>
        </div>
    </div>
    <div>
        <div class="transfer-line" v-if="!isVip()">
            <button class="upgrade-now" @click.stop="switchToPay()">{{$t('language.common.upgradeNow')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import googleAnalyticsUtil from "../../../../js/workspace/google_analytics_util.js";
export default {
    props: ['flag', 'index', 'transferDetail', 'speed', 'detailShow', 'percent', 'transferDetailChange'],
    data: function () {
        return {
            itemDetail: this.transferDetail,
            detailHeight: 248,
            user:commonUtils.getUser(),
        }
    },
    watch: {
        transferDetailChange(newValue, oldValue) {
            this.$forceUpdate();
        },
          '$store.state.transferDetailChange': function (newValue, oldValue) {
            this.$forceUpdate();
            this.$parent.$forceUpdate();
            this.$parent.showTaskStatus();
        }
    },
    created() {
        if (this.transferDetail) {
            this.itemDetail = this.transferDetail;
        }
    },
    mounted() {

    },
    methods: {
        toSourceCatalog(item) {
            if(item.branchType==='share'){
                if(item.sharePath){
                    this.$store.commit("setSharePath", JSON.parse(JSON.stringify(item.sharePath)));
                }
                let link = item.shareUrl;
                window.open(link);
            }else{
                let fromItem = {
                    driveId: item.sourceToken,
                    nodes: item.sourceNode,
                    driveType: item.sourceCloudType,
                    name: item.sourceFilename,
                    id: item.sourceId
                };
                this.$parent.toSourceCatalog(fromItem);
            }
        },
        toAimCatalog(item) {
            let toItem = {
                driveId: item.desToken,
                nodes: item.desNode,
                driveType: item.desCloudType,
                name: item.desNode[0].fileName,
                id: item.desId
            };
            this.$parent.toAimCatalog(toItem);
        },
        switchToPay() {
            googleAnalyticsUtil.pay1(this,"threads");
            commonUtils.switchToPay();
        },
        isVip() {
            let flag = commonUtils.isVip();
            let boxHeight = 390;
            if (flag) {
                boxHeight = 350;
            } else {
                boxHeight = 390;
            }
            if(this.transferDetail&&!this.transferDetail.entities){
                 this.transferDetail.entities=[];
            }
            this.$parent.$refs.threadParents.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
            
            let dom = this.$parent.$refs.threadParents.parentElement;
            let pDom = this.$parent.$refs.threadParents.parentElement.parentElement;
            dom.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
            pDom.style.height = (this.transferDetail.entities.length) * 25 + boxHeight + 'px';
            return flag;
        },
          getTitle(item){
           var title;
           title=commonUtils.getCatalog(item.fileNode);
           title = title +'\\'+item.filename;
           return title;
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 39) {
                return value.slice(0, 39) + '...';
            }
            return value;
        },
    }
}
</script>

<style scoped>
.transfers-detail {
    width: 100%;
    height: 100%;
    height: 248px;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding: 10px 20px 16px 20px;
    /*no*/
}

.transfers-detail-title {
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #000;

}

.detail-one {
    width: 100%;
    height: 35px;
    /*no*/
    margin: 10px 0px 16px 0px;
    /*no*/
}


.detail-two {
    width: 100%;
    height: 50px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-three {
    width: 100%;
    height: 35px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-four {
    width: 100%;
    height: 35px;
    /*no*/
}

.transfer-line {
    width: 100%;
}

.transfer-column-left {
    width: 38%;
    float: left;
    margin-right: 3%;

}

.transfering-file-line {
    height: 25px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.transfer-column-right {
    width: 56%;
    float: left;

}

.transfer-line-des {
    line-height: 40px;
    /*no*/
}

.catelog-style {
    max-width: 1000Px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_transfer_detail.vue